export const FETCH_MAKE_MODEL_YEAR_REQUEST = 'FETCH_MAKE_MODEL_YEAR_REQUEST';
export const FETCH_MAKE_MODEL_YEAR_SUCCESS = 'FETCH_MAKE_MODEL_YEAR_SUCCESS';
export const FETCH_MAKE_MODEL_YEAR_FAILURE = 'FETCH_MAKE_MODEL_YEAR_FAILURE';